import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { getGoogleClickId } from 'Hooks/useGoogleAdsGclid'
import { getGoogleUtmObj } from 'Hooks/useGoogleUtm'
import useMobileDetect from 'Hooks/useMobileDetect'
import {
  PhoneInput,
  HiddenSubmit,
  SquareCheckboxWithLabel,
  Input,
} from 'Components/Form'

import {
  GOOGLE_UTM_CAMPAIGN,
  GOOGLE_UTM_MEDIUM,
  GOOGLE_UTM_SOURCE,
  GOOGLE_UTM_TERM,
} from 'Defaults/googleAds'

import {
  _Col,
  _Signup,
  _SubmitCta,
  _SecondStep,
  _IamAgentCol,
  _AgentErrorTitle,
  _SlidingModalTitle,
  _ErrorText,
} from './styles'

const SSOSignup = ({
  errors,
  className,
  // modalSource,
  resetSignupProcess = () => {},
  hasDelivraAccount,
  googleAnalyticsEvent = () => {},
  gate,
  SSOUserInfo,
  userGoogleSignup,
  isMobileApp,
  userCurrentArea,
  loginPage,
  userDataIsFetching,
}) => {
  const { first, last, email, complete } = SSOUserInfo || {}
  const { isIos } = useMobileDetect()
  const [iAmAgent, setIAmAgent] = useState(false)
  const [newspaperSubscribed, setNewspaperSubscribed] = useState(false)
  const [phoneInputVal, setPhoneInputVal] = useState('')
  const [phoneCountryCode, setPhoneCountryCode] = useState('+1')
  const [lastName, setLastName] = useState(last)
  const platform = !isMobileApp ? 'web' : isIos ? 'ios' : 'android'
  const googleAnalyticsEventHandler = (action) => {
    googleAnalyticsEvent({
      category: 'GoogleSSO',
      action,
    })
  }
  useEffect(() => () => {
    resetSignupProcess()
  }, [])
  const buttonText = !complete ? 'Create an Account' : 'Update Account'
  const completeGoogleSignup = event => {
    event.preventDefault()
    const obj = {
      first_name: first,
      last_name: lastName,
      email,
      phone: phoneInputVal.replace(/[\s\-\(\)]/g, ''),
      phone_country_code: phoneCountryCode,
      gate,
      hasMobileApp: Boolean(isMobileApp),
      platform,
    }
    const googleClickId = getGoogleClickId()
    if(googleClickId) {
      obj.googleClickId = googleClickId
    }
    const googleUtmObj = getGoogleUtmObj()
    if(googleUtmObj) {
      obj[GOOGLE_UTM_CAMPAIGN] = googleUtmObj[GOOGLE_UTM_CAMPAIGN]
      obj[GOOGLE_UTM_MEDIUM] = googleUtmObj[GOOGLE_UTM_MEDIUM]
      obj[GOOGLE_UTM_SOURCE] = googleUtmObj[GOOGLE_UTM_SOURCE]
      obj[GOOGLE_UTM_TERM] = googleUtmObj[GOOGLE_UTM_TERM]
    }

    if(userCurrentArea && userCurrentArea.areaType) {
      obj.area_id = userCurrentArea.areaId
      obj.area_type = userCurrentArea.areaType
    }
    userGoogleSignup(obj)
    googleAnalyticsEventHandler('Complete Sign Up')
  }

  const newsletterCheckboxesUpdate = event => {
    const checked = event.target.checked
    setNewspaperSubscribed(checked)
    googleAnalyticsEventHandler(`[News letter, ${checked ? 'Check' : 'UnCheck'}]`)
  }
  const iAmAgentCheckbox = event => {
    const checked = event.target.checked
    setIAmAgent(checked)
    googleAnalyticsEventHandler(`[I am agent Click, ${checked ? 'Check' : 'UnCheck'}]`)
  }

  const phoneNumberUpdate = inputData => {
    setPhoneCountryCode(inputData.code)
    setPhoneInputVal(inputData.phone)
  }

  return (
    <_Signup
      className={className}
      data-test-id={'SSOSignup'}
      loginPage={loginPage}
    >
      <h4>{!complete ? 'Create an Account' : 'Update Account'}</h4>
      <_SlidingModalTitle>
        {!complete ? `Add your phone number ${!last ? 'and last name ' : ''}to finish creating
        your account` : 'Please update  your account to continue'}
      </_SlidingModalTitle>
      <_SecondStep data-test-id={'signupSSOStep'}>
        <form
          data-test-id="SSOform"
          onSubmit={event => completeGoogleSignup(event)}
          method="POST"
        >
          {!last && (
            <_Col>
              <Input
                id="lastName"
                name="lastName"
                type="text"
                placeholder={'Last Name'}
                onChange={data => {
                  setLastName(data.value)
                }}
                value={lastName}
                required
              />
            </_Col>
          )}
          <_Col>
            <PhoneInput
              id="phone"
              onChange={phoneNumberUpdate}
              required
            />
          </_Col>
          {!hasDelivraAccount && (
            <_Col isCheckboxCol>
              <SquareCheckboxWithLabel
                id="Subscribed"
                name="Subscribed"
                label="Get market news, insights & expert advice delivered to your inbox. We won't spam you!" // eslint-disable-line
                onChange={newsletterCheckboxesUpdate}
                checked={newspaperSubscribed}
              />
            </_Col>
          )}

          <_IamAgentCol isCheckboxCol iAmAgent={iAmAgent}>
            <SquareCheckboxWithLabel
              id="registeredAgent"
              name="registeredAgent"
              label="I am a registered real estate agent" // eslint-disable-line
              onChange={iAmAgentCheckbox}
              checked={iAmAgent}
            />
            {iAmAgent ? (
              <>
                <_AgentErrorTitle>
                  <strong>Account Creation Alert</strong>
                </_AgentErrorTitle>
                Thank you for your interest. Account creation for agents is
                currently unavailable due to TRREB&apos;s data sharing restrictions.{' '}
                If you have any questions, please do not hesitate to{' '}
                <a
                  target="_black"
                  href="https://hq.property.ca/contact-us/"
                  title="contact us"
                >
                  contact us
                </a>
                .
              </>
            ) : (
              ''
            )}
          </_IamAgentCol>
          <_Col>
            {errors && Array.isArray(errors) && errors.length > 0 && <_ErrorText>{errors[0]}</_ErrorText>}
            <_SubmitCta primary medium buttonType="submit" disabled={iAmAgent} loading={userDataIsFetching}>
              {buttonText}
            </_SubmitCta>
          </_Col>

          <_Col isTermsConditionsCol>
            By creating an account you acknowledge that you have read and agree
            to the&nbsp;
            <Link to="/terms" target="_blank">
              Terms of Service
            </Link>
            &nbsp;&amp;&nbsp;
            <Link to="/privacy" target="_blank">
              Privacy Policy
            </Link>
            .
          </_Col>
        </form>
      </_SecondStep>
      <HiddenSubmit />
    </_Signup>
  )
}

SSOSignup.propTypes = {
  errors: PropTypes.array,
  userDataIsFetching: PropTypes.bool,
  resetSignupProcess: PropTypes.func,
  className: PropTypes.string,
  gate: PropTypes.string,
  hasDelivraAccount: PropTypes.bool,
  // modalSource: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  loginPage: PropTypes.bool,
  userGoogleSignup: PropTypes.func,
  isMobileApp: PropTypes.bool,
  userCurrentArea: PropTypes.shape({
    areaId: PropTypes.number,
    areaType: PropTypes.string,
  }),
  SSOUserInfo: PropTypes.shape({
    first: PropTypes.string,
    last: PropTypes.string,
    email: PropTypes.string,
  }),
}

export default SSOSignup
